/**
 * Parametric - Параметрический
 */

import axios from 'axios';
import FilterParam from './templates/filter-param';
import FilterPopup from './templates/filter-popup';
import History from 'components/history';
import ParametricMap from './templates/map';
import ParametricPopupMap from './templates/map-popup';
import ParametricResult from './templates/results';
import Utils from 'common/scripts/utils';

class Parametric {
    constructor(options) {
        this.options = options;
        this.containerSelector = '.j-parametric';
        this.container = document.querySelector(this.containerSelector);
        this.formSelector = '.j-parametric-form';

        this.textSelector = '.j-parametric-text';
        this.textToggleSelector = '.j-parametric-text-toggle';
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initFilter();
        this._initFilterPopup();
        this._initResult();
        this._bindToggleText();

        this._send('first');
    }

    _initElements() {
        this.form = this.container.querySelector(this.formSelector);

        this.text = this.container.querySelector(this.textSelector);
        this.textToggle = this.container.querySelector(this.textToggleSelector);
    }

    _initFilter() {
        this.filter = new FilterParam({
            wrapper     : this.container,
            clickShowAll: () => {
                this.filterPopup.open();
            },
            afterChange: Utils.debounce(this._send.bind(this), 500),
            clickSubmit: () => {
                this.result.anchorTop();
            }
        });
    }

    _initFilterPopup() {
        this.filterPopup = new FilterPopup({
            wrapper    : this.container,
            afterSubmit: () => {
                this._send();
            },
            afterChange: () => {
                this._send('changePopup');
            }
        });
    }

    _initResult() {
        this.result = new ParametricResult({
            wrapper      : this.container,
            changeSorting: () => {
                this._send('sort');
            },
            changePagination: () => {
                this._send('page');
            },
            changeTab: (type) => {
                if (type === 'flats' && this.map) {
                    this.map.fitBounds();
                }
            },
            clickElected: (id, action) => {
                const data = new FormData();

                data.append('id', id);
                data.append('action', action);

                this._sendElected(data);
            },
            mouseenterComplex: (id) => {
                this.map.activeOnlyMarker(id);
                this.map.centerMarker(id);
            },
            mouseleaveComplex: () => {
                this.map.activeOnlyMarker();
            },
            mouseenterFlat: (id) => {
                this.map.activeOnlyMarker(id);
            },
            mouseleaveFlat: () => {
                this.map.activeOnlyMarker();
            }
        });
    }

    _initMap(data) {
        this.map = new ParametricMap({
            wrapper: this.container,
            ...data
        });
    }

    _initPopupMap(data) {
        this.mapPopup = new ParametricPopupMap({
            wrapper        : this.container,
            ...data,
            clickLinkParams: () => {
                this.filterPopup.open();
            },
            clickLinkComplex: () => {
                this.result.anchorTop();
                this.result.checkTabByType('complex');
            }
        });
    }

    // eslint-disable-next-line
    _send(typeReq) {
        const formData = new FormData(this.form);
        const action = this.form.action;
        const sort = this.result.getSort();

        if (typeReq === 'page') {
            formData.append('page', History.get('page') || 1);
        }

        if (typeReq !== 'changePopup' && typeReq !== 'first' && typeReq !== 'page') {
            this.result.anchorTopFromBottom();
        }

        formData.append('sort_type', sort.type);
        formData.append('sort_turn', sort.turn);

        //  if (typeReq !== 'changePopup') {
        //     History.clear();
        //     History.appendFromFormData(formData);
        // }

        // axios.get('/tests/parametric/parametric.json', formData)
        axios.post(action, formData)
            // eslint-disable-next-line max-lines-per-function,max-statements
            .then((response) => {
                const {data} = response;

                if (typeReq === 'changePopup' && data.textSubmit) {
                    this.filterPopup.replaceSubmitText(data.textSubmit);

                    if (data.noResult) {
                        this.filterPopup.disableButton();
                    } else {
                        this.filterPopup.enableButton();
                    }

                    return;
                }

                if (data.map && typeReq === 'first') {
                    this._initMap(data.map);
                    this._initPopupMap(data.map);
                }

                if (data.textSubmit) {
                    this.filter.replaceSubmitText(data.textSubmit, data.textSubmitTiny);
                    this.filterPopup.replaceSubmitText(data.textSubmit);
                }

                if (data.title) {
                    this.result.replaceTitle(data.title);
                }

                if (data.pagination && typeReq !== 'page') {
                    this.result.updatePagination(data.pagination);
                }

                if (data.complexes) {
                    this.result.replaceComplexes(data);

                    if (this.map) {
                        const complexMarkers = data.complexes.map((complex) => {
                            return {
                                ...complex.marker,
                                id  : complex.id,
                                data: complex
                            };
                        });

                        this.map.removeMarkers();
                        this.map.addMarkersInMap(complexMarkers);
                        this.map.fitBounds();

                        this.mapPopup.removeMarkers();
                        this.mapPopup.addMarkersInMap(complexMarkers);
                        this.mapPopup.fitBounds();
                    }
                }

                if (data.flats) {
                    this.result.replaceFlats(data);
                }

                if (data.noResult) {
                    this.result.showNoResult();
                    this.filter.disableButton();
                    this.filterPopup.disableButton();
                } else {
                    this.result.hideNoResult();
                    this.filter.enableButton();
                    this.filterPopup.enableButton();
                }

                if (data.url && typeReq !== 'first') {
                    history.pushState(null, null, data.url);
                }

                this.map.stickyUpdate();
            })
            .catch((error) => { // eslint-disable-line
                console.error(error); // eslint-disable-line
            });
    }

    _sendElected(formData) {
        const action = this.form.action;
        const method = this.form.method.toLowerCase();

        axios[method](action, formData)
            .catch((error) => { // eslint-disable-line
                console.error(error); // eslint-disable-line
            });
    }

    _bindToggleText() {
        this.textToggle.addEventListener('click', () => {
            if (this.textToggle.classList.contains('is-open')) {
                this.textToggle.classList.remove('is-open');
                this.text.style.maxHeight = '0';
            } else {
                this.textToggle.classList.add('is-open');
                this.text.style.maxHeight = `${this.text.scrollHeight}px`;
            }
        });
    }
}

export default Parametric;
